// extracted by mini-css-extract-plugin
export default {"CopyToClipboard":"CopyToClipboard1605sk0q8t0p"};